"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapService = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const index_1 = require("./index");
const MAP_OPTIONS = {
    /* Disable clicking points of interest. This makes it confusing when trying to click on collections. */
    clickableIcons: false,
    /* Disable 45° camera angle in satellite map mode. Only top-down angle will position collections accurately. */
    tilt: 0,
    /* Feature works but is not tested. Disable until asked for. */
    rotateControl: false,
};
class MapService {
    constructor() {
        this.__priority = 100;
        this.isReady = false;
    }
    init() {
        this.isReadyPromise = new Promise((resolve) => {
            const waitForGoogleMaps = index_1.Services.Window.window.setInterval(() => {
                if (typeof google === 'undefined') {
                    return;
                }
                index_1.Services.Window.window.clearTimeout(waitForGoogleMaps);
                this.setIsReady();
                resolve();
            }, 10);
        });
    }
    /**
     * Fetch Google Map instance, reusing existing instance to avoid impacting Google Maps API quota.
     */
    get map() {
        if (!this.isReady) {
            throw new Error('Cannot fetch map before Google Maps API loaded');
        }
        if (this.mapInstance == null) {
            const mapEl = index_1.Services.Window.document.createElement('div');
            mapEl.style.width = '100%';
            mapEl.style.height = '100%';
            this.mapInstance = new google.maps.Map(mapEl, MAP_OPTIONS);
        }
        return this.mapInstance;
    }
    attach(el) {
        const map = this.map;
        if (map == null) {
            return null;
        }
        el.appendChild(map.getDiv());
        return map;
    }
    setIsReady() {
        this.isReady = true;
    }
}
exports.MapService = MapService;
tslib_1.__decorate([
    mobx_1.observable
], MapService.prototype, "isReady", void 0);
tslib_1.__decorate([
    mobx_1.action
], MapService.prototype, "setIsReady", null);
//# sourceMappingURL=map.service.js.map